import * as React from 'react';
import {
  Card, CardContent, CardMedia,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from "@mui/material";
import HomePic from '../../images/menu/Trail Mix2.jpeg'
import {WheatIcon} from "../icon/WheatIcon";
import {Stack} from "@mui/system";
import BizName from "../../images/biz_name_only.svg";

function Home(props) {

  return (
          <Grid container sx={{width: '100%'}} padding={2}
                paddingLeft={{xs: '5%', sm: '10%', md: '30%', lg: '30%'}} paddingRight={{xs: '5%', sm: '10%', md: '30%', lg: '30%'}}
                justifyContent={'center'} alignItems={'center'}>
            <Stack spacing={1}>
              <Typography align={'center'}>
                <img alt={''} src={BizName} width={'70%'} height={'70%'}/>
              </Typography>
              <Typography align={'center'}>
                Neighborhood Nano Bakery
              </Typography>
              <Typography fontWeight={500} fontStyle={'italic'} fontSize={12} align={'center'}>
                Minnesota Cottage Food Producer #20277484
              </Typography>

              <Typography fontSize={14} align={'center'}>
                Bread Drop preorders: <a href={'https://www.hotplate.com/minnehaha.bread'} target={'_blank'} rel="noreferrer">Hotplate Store</a>
              </Typography>
              <Typography fontSize={14} fontStyle={'italic'} fontWeight={600} align={'center'}>

              </Typography>
              <Card variant={'elevation'} elevation={5}>
                <CardContent sx={{marginTop: -1, marginBottom: -3}}>
                  <Grid container justifyContent={'center'} alignItems={'center'}>
                    <Grid container spacing={1}>
                      <Typography align={'center'}>
                        <b>November 2, 2026<br/></b>
                      </Typography>
                    </Grid>
                    <Grid container justifyContent={'center'} alignItems={'center'}>
                      <Typography fontSize={14} align={'center'}>
                        <i>Drop this Friday, <b>Nov 6</b></i><br/>
                        Pre-orders 11/2 @7pm - 11/3 @7pm<br/>
                        <b>Trail Mix & Minnehaha Sourdough</b>
                      </Typography>
                      <List sx={{marginLeft: '5%'}}>
                        <ListItem dense={true}>
                          <ListItemIcon>
                            <WheatIcon />
                          </ListItemIcon>
                          <ListItemText sx={{marginLeft: -3}}>
                            Check for drop details <a href={'https://www.hotplate.com/minnehaha.bread'} target={'_blank'} rel="noreferrer">here</a>
                          </ListItemText>
                        </ListItem>
                      </List>
                    </Grid>
                  </Grid>
                  <CardMedia sx={{marginBottom: 2}} component="img" image={HomePic}/>
                </CardContent>
              </Card>
            </Stack>
          </Grid>
  )
}

export { Home }